var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c("v-card-title", [
        _vm._v(" " + _vm._s(_vm.$t("lessonPlaner.title")) + " ")
      ]),
      _c(
        "v-card-text",
        [
          _c("v-container", { attrs: { id: "summary" } }, [
            _vm.numModules > 0
              ? _c("p", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("lessonplanner.summary", [
                          _vm.numModules,
                          _vm.totalDuration
                        ])
                      ) +
                      " "
                  )
                ])
              : _c("p", [
                  _vm._v(" " + _vm._s(_vm.$t("lessonplanner.empty"))),
                  _c("br")
                ])
          ]),
          _vm.loading
            ? _c("v-progress-linear", {
                attrs: { indeterminate: "", color: "primary" }
              })
            : _vm._e(),
          _vm.loading
            ? _c("spin", [_vm._v(" " + _vm._s(_vm.$t("global.loading")) + " ")])
            : _vm._e(),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  !_vm.loading
                    ? _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("global.search"),
                          clearable: ""
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-col",
                [
                  _c("v-switch", {
                    attrs: { label: _vm.$t("lessonplanner.show-all-locales") },
                    model: {
                      value: _vm.hideAllLocales,
                      callback: function($$v) {
                        _vm.hideAllLocales = $$v
                      },
                      expression: "hideAllLocales"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-container",
        { staticClass: "scrollable-container" },
        [
          !_vm.loading
            ? _c("v-data-iterator", {
                attrs: {
                  items: _vm.filteredModules,
                  "items-per-page": -1,
                  "hide-default-footer": ""
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(props) {
                        return [
                          _c(
                            "v-expansion-panels",
                            { attrs: { dense: "" } },
                            _vm._l(props.items, function(item) {
                              return _c(
                                "v-expansion-panel",
                                { key: item.title, attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-expansion-panel-header",
                                    { attrs: { dense: "" } },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "title-switch",
                                        attrs: {
                                          dense: "",
                                          inset: "",
                                          label: _vm.itemTitle(item)
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.handleModuleClick(
                                              $event,
                                              item
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.selectionState[item.uid]
                                              .selected,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.selectionState[item.uid],
                                              "selected",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "selectionState[item.uid].selected"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-expansion-panel-content",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "margins" },
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("v-img", {
                                                    attrs: { src: item.image }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "description",
                                                  attrs: { cols: "6" }
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.itemDescription(
                                                            item
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]),
                                                  _c("p", [
                                                    _vm.itemGuideLink(item)
                                                      ? _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: _vm.itemGuideLink(
                                                                item
                                                              ),
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "lessonplanner.tutor-notes"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]),
                                                  _c(
                                                    "p",
                                                    [
                                                      _vm._l(
                                                        _vm.itemSupportedLanguages(
                                                          item
                                                        ),
                                                        function(
                                                          language,
                                                          index
                                                        ) {
                                                          return _c(
                                                            "v-chip",
                                                            {
                                                              key: index,
                                                              staticClass:
                                                                "mr-2"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    language
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      _c("br")
                                                    ],
                                                    2
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          item.topics &&
                                          item.navigationType === "free"
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "mt-3" },
                                                    [
                                                      _c("em", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "lessonplanner.topics-header",
                                                              [
                                                                _vm.moduleDuration(
                                                                  item,
                                                                  true
                                                                )
                                                              ]
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "6" }
                                                        },
                                                        _vm._l(
                                                          _vm.topicsSlice(
                                                            item,
                                                            0
                                                          ),
                                                          function(topic, i) {
                                                            return _c(
                                                              "v-checkbox",
                                                              {
                                                                key: i,
                                                                staticClass:
                                                                  "slim",
                                                                attrs: {
                                                                  label: _vm.itemCheckpoint(
                                                                    item,
                                                                    topic
                                                                  ),
                                                                  disabled: !_vm
                                                                    .selectionState[
                                                                    item.uid
                                                                  ].selected
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .selectionState[
                                                                      item.uid
                                                                    ].topics[
                                                                      topic.id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .selectionState[
                                                                        item.uid
                                                                      ].topics,
                                                                      topic.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "selectionState[item.uid].topics[topic.id]"
                                                                }
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "6" }
                                                        },
                                                        _vm._l(
                                                          _vm.topicsSlice(
                                                            item,
                                                            1
                                                          ),
                                                          function(topic, i) {
                                                            return _c(
                                                              "v-checkbox",
                                                              {
                                                                key: i,
                                                                staticClass:
                                                                  "slim",
                                                                attrs: {
                                                                  label: _vm.itemCheckpoint(
                                                                    item,
                                                                    topic
                                                                  ),
                                                                  disabled: !_vm
                                                                    .selectionState[
                                                                    item.uid
                                                                  ].selected
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .selectionState[
                                                                      item.uid
                                                                    ].topics[
                                                                      topic.id
                                                                    ],
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .selectionState[
                                                                        item.uid
                                                                      ].topics,
                                                                      topic.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "selectionState[item.uid].topics[topic.id]"
                                                                }
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      item.navigationType === "free"
                                        ? _c("div", { staticClass: "tip" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "lessonPlanner.version-warning"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2466472390
                )
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _c("v-btn", { attrs: { color: "blue" }, on: { click: _vm.cancel } }, [
            _vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")
          ]),
          _c(
            "v-btn",
            { attrs: { color: "primary" }, on: { click: _vm.save } },
            [_vm._v(" " + _vm._s(_vm.$t("global.save")) + " ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }